
export enum TimeOfDayCategory {
    AllDay = 1,
    AM = 10,
    PM = 20,
    Time = 50
}
